import { navigateAcrossMFEs, useCurrentUser } from '@qualio/ui-components';
import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../api/model/document';
import { DocumentOverviewContext } from '../../Context';
import {
  documentIsInApprovalStatus,
  documentIsInTrainingStatus,
  shouldRenderActivityReportItem,
} from '../../RenderLogic';

type ActivityReportActionProps = {
  renderClickableItem: (onClick: () => void, label: string) => JSX.Element;
};

const getActivityReportActionItemLabel = (
  documentStatus: string,
  trainingAvailable: boolean,
  t: any,
) => {
  if (documentStatus === DocumentStatus.For_Review) {
    return t('labels.review');
  } else if (documentIsInApprovalStatus(documentStatus)) {
    return t('labels.approval');
  } else if (documentIsInTrainingStatus(documentStatus, trainingAvailable))
    return t('labels.training');

  return '';
};

export const ActivityReportAction = ({
  renderClickableItem,
}: ActivityReportActionProps) => {
  const { t } = useTranslation();
  const { qualioDocument, currentEditorMode } = useContext(
    DocumentOverviewContext,
  );
  const currentUser = useCurrentUser();

  const documentStatus = qualioDocument.status_id;
  const trainingAvailable = qualioDocument.training_available;

  const reportStatusLabel = useMemo(() => {
    return getActivityReportActionItemLabel(
      documentStatus,
      trainingAvailable,
      t,
    );
  }, [documentStatus, trainingAvailable, t]);

  const handleClick = () => {
    const activityReportPath = `/reports/activity/${
      qualioDocument.id
    }/${reportStatusLabel.toLowerCase()}`;
    navigateAcrossMFEs(activityReportPath);
  };

  if (
    !shouldRenderActivityReportItem(
      qualioDocument,
      currentUser,
      currentEditorMode,
    )
  ) {
    return null;
  }

  return (
    <>
      {renderClickableItem(
        handleClick,
        `${reportStatusLabel}${t('labels.report')}`,
      )}
    </>
  );
};
